import Decimal from 'decimal.js';
import { useMemo } from 'react';
import { StyledDataSum } from '../../atoms/SettlementsDoneDataElement/StyledDataSum';
import { StyledText } from '../../atoms/Text/StyledText';
import { getString } from '../../../strings';

const MonthSummary = ({ val, hours, currentKey }) => {
    const hoursAmount = useMemo(() => {
        if (!val) return new Decimal(0);

        return (val.lessons || []).reduce((prev, cur) => {
            if (!cur) return prev;

            const value = cur.hours > 0 ? cur.hours : cur.half ? 0.5 : 0;

            return prev.plus(value);
        }, new Decimal(0));
    }, [val]);

    const avgHoursForMonth = useMemo(() => {
        if (!hours) return new Decimal(0);

        if (!currentKey) return new Decimal(0);

        const [CURRENT_YEAR, currentMonth] = currentKey.split('-');
        const START_YEAR = 2023;

        const matchingMonths = Object.entries(hours).filter(([key]) => {
            const [year, month] = key.split('-').map(Number);
            return (
                year >= START_YEAR &&
                year < CURRENT_YEAR &&
                String(month).padStart(2, '0') === currentMonth
            );
        });

        if (!matchingMonths.length) return new Decimal(0);

        const total = matchingMonths.reduce((sum, [, arr]) => {
            const monthSum = (arr?.lessons || []).reduce((prev, cur) => {
                if (!cur) return prev;

                const value = cur.hours > 0 ? cur.hours : cur.half ? 0.5 : 0;

                return prev.plus(value);
            }, new Decimal(0));

            return sum.plus(monthSum);
        }, new Decimal(0));

        return total.div(matchingMonths.length).ceil();
    }, [hours]);

    return (
        <StyledDataSum>
            <div>
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredfontcolor="#6786BE"
                    hasdeclaredtexttransform="uppercase"
                >
                    {getString('open_element_godziny')}:{' '}
                    <span style={{ color: '#000' }}>
                        {hoursAmount ? hoursAmount.toString() : '0'}
                    </span>
                </StyledText>
            </div>
            <div>
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredfontweight="600"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredfontcolor="#6786BE"
                    hasdeclaredtexttransform="uppercase"
                >
                    {getString('user_panel_all_trainer_pay_avg')}:{' '}
                    <span style={{ color: '#000' }}>{avgHoursForMonth.toString()}</span>
                </StyledText>
            </div>
        </StyledDataSum>
    );
};

export default MonthSummary;
